import 'uni-pages';
import Vue from 'vue'
import Page from './pages/personalCenter/notify.vue'
createPage(Page)